module.exports = __webpack_public_path__ + "img/student1.8393ebb5.svg";